import Icon from "@/components/Icon/Icon";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";
import { memo } from "react";
import type { ScrollButtonProps } from "./types";

/**
 * タブナビゲーションのスクロールボタン
 *
 * 水平スクロール可能なナビゲーションで左右スクロールを行うボタン。
 * disabledの場合はボタン自体を表示しない
 */
export const ScrollButton = memo(function ScrollButton({
  direction,
  onClick,
  disabled,
  className,
}: ScrollButtonProps) {
  // disabledの場合は何も表示しない
  if (disabled) return null;

  // 左右の方向を判定
  const isLeft = direction === "left";

  // アイコン名を方向に基づいて決定
  const iconName = isLeft ? "ChevronLeft" : "ChevronRight";

  // アクセシビリティラベルを方向に基づいて決定
  const ariaLabel = `${isLeft ? "左" : "右"}にスクロール`;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className={cn(
        "absolute z-10 h-8 w-8 rounded-full bg-background shadow-md",
        isLeft ? "left-0" : "right-0",
        className,
      )}
      aria-label={ariaLabel}
      type="button"
    >
      <Icon iconName={iconName} size={16} colorVariant="muted" />
    </Button>
  );
});
